import { Alert, Box, Button, Modal, Snackbar } from '@mui/material';
import React, { useState } from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: { xs: '70%', sm: '40%', md: '30%' },
  //   maxWidth: { xs: '70%', md: '40%' },
  bgcolor: 'background.paper',
  p: 1,
  borderRadius: 1
};

export default function DisplayHelpCenterImageModal({
  openAssignedModal,
  handleClose,
  displayImage
}) {
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Modal
        open={openAssignedModal}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="DisplayHelpCenterImage"
      >
        <Box sx={style}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={displayImage?.image}
              alt="imageee"
              style={{
                width: '250px',
                height: '250px',
                objectFit: 'contain',
                borderRadius: '10px'
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              marginTop: 1
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                handleClose();
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
